import angular from 'angular';

import EventReceiptModalComponent from './event-receipt-modal.cmpt';

export default angular
    .module('application.component.modals.component.event-receipt-modal', [])
    .component(EventReceiptModalComponent.selector, EventReceiptModalComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/event-receipt-modal/index.js